import { FilterDocument } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';
import { DueDisplayOptions } from 'shared/types/task-base';
import { Timestamp } from 'shared/types/timestamp';

export type NoGroupingRenderData = {
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  filterDocument?: FilterDocument;
  defaultNewTaskDate?: Timestamp;
  goalId?: ID;
  lifeAreaId?: ID;
  tagId?: ID;
  displayDue?: DueDisplayOptions[];
  showRepeatingAsTodo?: boolean;
  hideNewTaskRow?: boolean;
};

export const NoGroupingRenderDataContext =
  createContext<NoGroupingRenderData | null>(null);

export const useNoGroupingRenderData = (): NoGroupingRenderData => {
  const data = useContext(NoGroupingRenderDataContext);
  if (!data) {
    throw new Error(
      'useNoGroupingRenderData must be used within a NoGroupingTaskListRenderer',
    );
  }
  return data;
};
